import { render } from "./HeaderRegions.vue?vue&type=template&id=238613da"
import script from "./HeaderRegions.vue?vue&type=script&lang=js"
export * from "./HeaderRegions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yourkesa/Downloads/qron_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__